(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  function initGallery(gallery) {
    const allImgs = gallery.querySelectorAll('.product-media__image');
    if (allImgs.length < 2) return;
    if (gallery.dataset.imgOff) return; // already initialized

    gallery.dataset.imgOff       = allImgs[0].src;
    gallery.dataset.imgOn        = allImgs[1].src;
    gallery.dataset.imgOffSrcset = allImgs[0].srcset;
    gallery.dataset.imgOnSrcset  = allImgs[1].srcset;
  }

  function applyStateToGallery(gallery, isOn) {
    initGallery(gallery);

    const allImgs = gallery.querySelectorAll('.product-media__image');
    if (allImgs.length < 2) return;

    const firstImg = allImgs[0];
    firstImg.src    = isOn ? gallery.dataset.imgOn    : gallery.dataset.imgOff;
    firstImg.srcset = isOn ? gallery.dataset.imgOnSrcset : gallery.dataset.imgOffSrcset;
  }

  function applyLightsState(isOn) {
    document.querySelectorAll('.card-gallery').forEach(gallery => {
      applyStateToGallery(gallery, isOn);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    const btn   = document.getElementById('lh-lights-toggle');
    const label = document.getElementById('lh-lights-label');
    if (!btn) return;

    let isOn = false;

    // Initialize first batch
    applyLightsState(false);

    btn.addEventListener('click', function () {
      isOn = !isOn;
      btn.classList.toggle('is-on', isOn);
      btn.setAttribute('aria-pressed', isOn);
      label.textContent = isOn ? 'Lights On' : 'Lights Off';
      applyLightsState(isOn);
    });

    // ✅ Correct container: [infinite-scroll]
    const grid = document.querySelector('[infinite-scroll]');
    if (!grid) return;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType !== 1) return;

          // Collect all newly added galleries
          const galleries = node.classList && node.classList.contains('card-gallery')
            ? [node]
            : [...node.querySelectorAll('.card-gallery')];

          if (!galleries.length) return;

          // ✅ Small delay to ensure images are fully in the DOM
          setTimeout(() => {
            galleries.forEach(gallery => applyStateToGallery(gallery, isOn));
          }, 100);
        });
      });
    });

    observer.observe(grid, { childList: true, subtree: true });
  });

  } catch(e) { console.error(e); }
})();
})();
